import { coreStoreFeature } from './core-store.reducer';

const {
  selectCoreState,
  selectAppTags,
  selectUserMenuTags,
  selectCurrentUserRole,
  selectUserDetails,
  selectIsSwitchingRole,
  selectSignalRConnection,
  selectDropdownData,
  selectResizeApp,
  selectCurrentProfileTag,
  selectPortTreeData,
  selectSelectedKPI
} = coreStoreFeature;

export const coreStoreSelectors = {
  selectCoreState,
  selectAppTags,
  selectUserMenuTags,
  selectCurrentUserRole,
  selectUserDetails,
  selectIsSwitchingRole,
  selectSignalRConnection,
  selectDropdownData,
  selectResizeApp,
  selectCurrentProfileTag,
  selectPortTreeData,
  selectSelectedKPI
};
